import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Reveal, Arrow } from "./Reveal";
import { WA_LINK } from "./data";

const PKGS = [
  { id: "rumah", title: "Internet Rumah", sub: "Cepat, Stabil, Cocok untuk Keluarga", speed: "8 Mbps", price: "170.000", img: "/img/house.jpg", tint: "from-[#0b3fd1] via-[#1550e0]/85", chip: "text-vblue" },
  { id: "bisnis", title: "WiFi Bisnis", sub: "Solusi Internet untuk Usaha Anda", speed: "15 Mbps", price: "250.000", img: "/img/biz.jpg", tint: "from-[#c2410c] via-[#ea580c]/85", chip: "text-orange-600" },
];

const PackageCard = ({ p, i }) => (
  <Reveal delay={i * 0.1}>
    <motion.a href={WA_LINK} target="_blank" rel="noreferrer" data-testid={`package-${p.id}`} whileHover="hover" className="group relative block h-[260px] rounded-[28px] overflow-hidden bg-vnavy text-white shadow-[0_30px_60px_-30px_rgba(11,42,138,0.8)]">
      <motion.img variants={{ hover: { scale: 1.08 } }} transition={{ duration: 0.8 }} src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
      <div className={`absolute inset-0 bg-gradient-to-r ${p.tint} to-transparent`} />
      <div className="relative h-full p-7 flex flex-col">
        <h3 className="font-display text-2xl font-bold">{p.title}</h3>
        <p className="text-sm text-blue-100 mt-1 max-w-[180px]">{p.sub}</p>
        <span className={`mt-4 self-start rounded-lg bg-white ${p.chip} font-extrabold px-3 py-1 text-sm`}>{p.speed}</span>
        <div className="mt-auto flex items-end justify-between">
          <p data-testid={`package-${p.id}-price`} className="font-display"><span className="text-lg">Rp </span><span className="text-3xl font-extrabold">{p.price}</span><span className="text-sm text-blue-100"> /bulan</span></p>
          <motion.span variants={{ hover: { x: 4, backgroundColor: "#ffffff", color: "#1550e0" } }} className="w-10 h-10 rounded-full border-2 border-white grid place-items-center"><Arrow /></motion.span>
        </div>
      </div>
    </motion.a>
  </Reveal>
);

export const Packages = () => (
  <section id="layanan" data-testid="packages-section" className="relative bg-white py-24">
    <div className="max-w-[1320px] mx-auto px-5 lg:px-10">
      <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
        <div>
          <p className="eyebrow">Layanan</p>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-vnavy mt-2">Pilihan Paket Internet</h2>
          <p className="text-slate-600 mt-2 text-base md:text-lg">Untuk Rumah, Usaha dan Berbagai Kebutuhan</p>
          <span className="block w-12 h-1 rounded-full bg-gradient-to-r from-vblue to-sky-400 mt-4" />
        </div>
        <a href={WA_LINK} target="_blank" rel="noreferrer" data-testid="all-packages-btn" className="btn-ghost self-start sm:self-auto">Lihat Semua Paket <Arrow /></a>
      </Reveal>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PKGS.map((p, i) => <PackageCard key={p.id} p={p} i={i} />)}
        <Reveal delay={0.2} className="md:col-span-2 lg:col-span-1">
          <motion.div whileHover="hover" data-testid="package-area-baru" className="relative h-[260px] rounded-[28px] overflow-hidden text-white shadow-[0_30px_60px_-30px_rgba(11,42,138,0.8)]">
            <motion.img variants={{ hover: { scale: 1.08 } }} transition={{ duration: 0.8 }} src="/img/village.jpg" alt="Area baru" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-br from-[#047857] via-[#059669]/70 to-transparent" />
            <motion.span animate={{ y: [0, -10, 0] }} transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }} className="absolute right-10 top-10 w-14 h-14 rounded-full bg-gradient-to-br from-rose-500 to-red-600 grid place-items-center ring-4 ring-white shadow-xl">
              <MapPin size={26} />
            </motion.span>
            <div className="relative p-7 h-full flex flex-col">
              <h3 className="font-display text-2xl font-bold">Area Baru</h3>
              <p className="text-sm text-blue-50 mt-1 max-w-[200px]">Kami hadir lebih dekat di wilayah Anda</p>
              <a href="#area" data-testid="check-area-btn" className="mt-auto self-start inline-flex items-center gap-2 bg-white text-vnavy font-bold text-sm rounded-full px-5 py-2.5 hover:bg-sky-100 transition-colors">Cek Area Anda <Arrow /></a>
            </div>
          </motion.div>
        </Reveal>
      </div>
    </div>
  </section>
);
